import Text from 'components/Text/Text';
import React from 'react';
import { IComboGroupComboItem } from 'types';
import style from './ComboItemsScrollView.module.scss';

interface IComboItemsScrollView {
	data: IComboGroupComboItem[];
}

const ComboItemsScrollView: React.FC<IComboItemsScrollView> = ({ data }) => {
	return (
		<div className={style.container} data-test="ComboItemsScrollView">
			{data.length
				? data.map((el) => (
						<div key={el.comboItemId} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.comboItemName} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default ComboItemsScrollView;
